import axios from 'axios'
import qs from 'qs'
// const origin = location.origin
// const BASE_API = String.prototype.replace.call(process.env.BASE_API, /#/, origin)
// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API // api的base_url
  // timeout: 5000 // request timeout
})
// request interceptor
service.interceptors.request.use(config => {
  const timestamp = new Date().getTime()
  // Do something before request is sent
  // if (store.getters.token) {
  // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1NjYyMDA0NTksImFjY2Vzc0V4cCI6MTU2NjIwMDQ2MDgyNSwidXNlcklkIjoxMTUwNjQyOTU5MzkwMTE3ODg5LCJyZWZyZXNoRXhwVGltZSI6MTU2NjIwMDQ2MDgyNX0.AM6yre0sv8gq__kPfX4bKuVfCbaQ6KKpcIEKa8wU290'
  // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1NjYyMDUxNzQsImFjY2Vzc0V4cCI6MTU2NjIwNTE3NTYxNywidXNlcklkIjoxMTUwNjQyOTU5MzkwMTE3ODg5LCJyZWZyZXNoRXhwVGltZSI6MTU2NjIwNTE3NTYxN30.thlqid9JfZkMI0qN3iDMZeHxE_RPBtJuisaMT2X290s'
  // const token = '123'
  // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1NjY0NTg0MDYsImFjY2Vzc0V4cCI6MTU2NjQ1ODQwNzE3MCwidXNlcklkIjoxMTUwNjQyOTU5MzkwMTE3ODg5LCJyZWZyZXNoRXhwVGltZSI6MTU2NjQ1ODQwNzE3MH0.MqHUg0p7UUvcRWSzZRnclvYvSdRNwA7u9UILt4Q9bCY'
  // const token = getSession('token')
  // const sessionid = getSession('sessionid')
  // config.headers['token'] = token
  // config.headers['yz_session_id'] = sessionid
  // config.headers['User-Agent'] = 'Mozilla/5.0 (iPhone; CPU iPhone OS 9_1 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Version/9.0 Mobile/13B143 Safari/601.1 wechatdevtools/1.02.1907300 MicroMessenger/7.0.4 Language/zh_CN webview/'
  // }
  var reg = /\/test\/[\w/]+/
  // const inBody = config.method.toLowerCase() === 'post'
  const inBody = config.method.toLowerCase() === 'post' || config.method.toLowerCase() === 'put'
  if (!reg.test(config.url) && inBody) {
    if (config.data instanceof FormData) {
      // var data = new FormData()
      // config.data.append('token', token)
      config.data.append('timestamp', timestamp)
      return config
    }
    config.data = {
      // loginId: getLoginId(),
      body: config.data,
      // token: token,
      // signature: toMd5(getLoginId() + timestamp + key),
      timestamp: timestamp
    }
  }
  if ((config.method.toLowerCase() === 'delete' || config.method.toLowerCase() === 'get') && config.data) {
    // config.data.token = token
    config.data.timestamp = timestamp
    // qs.stringify(config.data, { arrayFormat: 'indices' })
    config.url = config.url + '?' + qs.stringify(config.data, { arrayFormat: 'repeat' })
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  response => {
    var data = response.data.body
    // const res = response.data
    // 获取授权信息失败就跳转至登录
    return data
  },
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  // response => {
  //   const res = response.data
  //   if (res.code !== 20000) {
  //     Message({
  //       message: res.message,
  //       type: 'error',
  //       duration: 5 * 1000
  //     })
  //     // 50008:非法的token 50012:其他客户端登录了  50014:Token 过期了
  //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //       // 请自行在引入 MessageBox
  //       // import { Message, MessageBox } from 'element-ui'
  //       MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //         confirmButtonText: '重新登录',
  //         cancelButtonText: '取消',
  //         type: 'warning'
  //       }).then(() => {
  //         store.dispatch('FedLogOut').then(() => {
  //           location.reload() // 为了重新实例化vue-router对象 避免bug
  //         })
  //       })
  //     }
  //     return Promise.reject('error')
  //   } else {
  //     return response.data
  //   }
  // },
  error => {
    // console.log('err' + error) // for debug
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/request/request.js